import React from 'react';
import Glob from "../../libs/Glob.mjs";
import "./MyCarousel.css";

const prefix = 'MyCarousel'

const MyCarousel = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			current: 0,
			delay: props.delay || 80
		};
		if ( props.items && props.items.length > 0) {
			this.state.items = [props.items[0]];
			this.state.len = 1;
		}
		this.adjust = this.adjust.bind(this);
		this.goto = this.goto.bind(this);
		this.uid = Glob.generateUid(prefix);
	}
	componentDidMount() {
		Glob.register('windowResized', ()=>{ this.goto(this.state.current ) }, this.uid );
		setTimeout( this.adjust );
	}
	componentWillUnmount() {
		Glob.unregister('windowResized', this.uid);
	}
	goto(x = 0, auto = false) {
		this.adjust();
		if ( this.state.timer ) try { window.clearTimeout( this.state.timer ) } catch( e ) {}
		if ( this.state.len < 2 ) return;
		let next = x +1;
		if ( next >= this.state.len ) next = 0;
		const delay = this.state.items[x].length * this.state.delay * ( auto ? 1 : 2) + 500;
		this.setState({
			current: x,
			timer: window.setTimeout( ()=>{ this.goto(next, true); }, delay )
		});
	}
	adjust() {
		const e = window.document.getElementById(this.uid);
		if  ( ! e ) {
			if ( this.state.items ) setTimeout( this.adjust, 100 );
			return false;
		}
		if ( this.state.timer ) try { window.clearTimeout( this.state.timer ) } catch( e ) {}
		const cs = window.getComputedStyle(e);
		const w = parseFloat(cs.getPropertyValue('width'));
		if ( w !== this.state.width ) {
			this.setState({
				items: this.props.items,
				len: this.props.items.length,
				width: w,
			}, ()=> { if ( ! this.state.timer ) this.goto(0,true) } );
			return true;
		}
		return false;
	}
	render() {
		if ( ! this.state.items ) return '';
		if ( ! this.state.timer ) setTimeout( ()=>{ this.goto(this.state.current, true) }, 100 );
		return(
			<div className={prefix} id={this.uid}>
				{ this.props.arrows && this.state.len > 1 && (
					<>
						<div
							className={"control previous "+(this.state.current ? 'active' : 'inactive')}
							onClick={ () => {
								if ( this.state.current ) this.goto(this.state.current -1);
							}}
						/>
						<div
							className={"control next "+(this.state.current +1 < this.state.len ? 'active' : 'inactive')}
							onClick={ () => {
								if ( this.state.current +1 < this.state.len ) this.goto(this.state.current +1);
							}}
						/>
					</>
				)}
				{ this.state.len > 1 && (
					<div className={"control nav"}>
						<div>
							{ this.state.items.map((item, i) =>(
								<div
									key={i}
									className={"step"+( i === this.state.current ? ' current' : '')}
									onClick={ ()=>{ this.goto( i )} }
								/>
							))}
						</div>
					</div>
				)}
				<div
					className={"box-container"}
					style={{
						width: this.state.width ? String(this.state.width * this.state.len) + 'px' : 'auto',
						marginLeft: this.state.width ? ( -1 * this.state.width * this.state.current)+'px' : '0'
					}}
				>
					{ this.state.items.map((item, i) =>(
						<div
							className={"box"+( i === this.state.current ? ' current' : '')}
							style={{ width: this.state.width ? String(this.state.width) + 'px' : 'auto' }}
							key={i}
						>
							<p className={"box-content"}>
								{ item }
							</p>
						</div>
					))}
				</div>
			</div>
		);
	}
}

export default MyCarousel;